var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { cx, css as emotionCss } from 'emotion';
import { BorderlessButton } from '@citrus/button';
import { Icon } from '@citrus/icon';
import { StarRating as Component } from './Rating.styled';
import { getAutomation, getDebug, useCitrusDebug } from '@citrus/runtime';
import { isNotNullOrEmpty } from '@pcty/utils';
import { buttonWidths } from './private/utils';
import { Legacy } from '@citrus/user';
var VERSION = '4.0.0-CDS4220.0';
var StarRating = React.forwardRef(function (_a, ref) {
    var _b;
    var automationId = _a.automationId, className = _a.className, css = _a.css, _c = _a.number, number = _c === void 0 ? 5 : _c, _d = _a.title, title = _d === void 0 ? 'rating' : _d, _e = _a.value, value = _e === void 0 ? 0 : _e, _f = _a.color, color = _f === void 0 ? 'blue' : _f, _g = _a.size, size = _g === void 0 ? 'small' : _g, _h = _a.disabled, disabled = _h === void 0 ? false : _h, onItemClick = _a.onItemClick, _j = _a.__TYPE, __TYPE = _j === void 0 ? 'StarRating' : _j, other = __rest(_a, ["automationId", "className", "css", "number", "title", "value", "color", "size", "disabled", "onItemClick", "__TYPE"]);
    var debug = useCitrusDebug();
    var _k = useState(value), selectedValue = _k[0], setSelectedValue = _k[1];
    var classes = cx((_b = {},
        _b[emotionCss(css)] = isNotNullOrEmpty(css),
        _b), className || '');
    var buttonClicked = function (ratingValue) {
        if (disabled)
            return;
        setSelectedValue(ratingValue);
        onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(ratingValue);
    };
    var items = [];
    var theValue = Math.round(selectedValue);
    var buttonWidth = buttonWidths[size];
    var _loop_1 = function (i) {
        var ratingValue = i;
        items.push(React.createElement(BorderlessButton, { disabled: disabled, key: "key-rating-".concat(i), onClick: function () { return buttonClicked(ratingValue); }, style: { margin: '0', padding: '0', width: buttonWidth } },
            React.createElement(Icon, { color: color, name: theValue > 0 && i <= theValue ? 'impressions-bold' : 'impressions', size: size, title: title })));
    };
    for (var i = 1; i <= number; i++) {
        _loop_1(i);
    }
    return (React.createElement(Legacy, null,
        React.createElement(Component, __assign({ className: classes, ref: ref }, other, getAutomation(automationId), getDebug(debug, __TYPE, VERSION)), items)));
});
StarRating.defaultProps = {
    __TYPE: 'StarRating',
};
export default StarRating;
